module.exports = __webpack_public_path__ + "static/media/dynamics365.11fb7860.png";